import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da65526c")

_pushScopeId("data-v-da65526c")
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { href: "/" }
const _hoisted_5 = { class: "main-blog" }
const _hoisted_6 = { class: "row justify-content-between pt-4" }
const _hoisted_7 = { class: "col-12 col-md-6" }
const _hoisted_8 = { class: "sidebar-box" }
const _hoisted_9 = { class: "display-3 text-blue mb-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "textwidget" }, null, -1)
const _hoisted_11 = { class: "col-12 col-md-6" }
const _hoisted_12 = { class: "h3 mb-0 contact-foot-box" }
const _hoisted_13 = { class: "sidebar-box" }
const _hoisted_14 = { class: "textwidget" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_header = _resolveComponent("top-header")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_top_header),
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("h2", { class: "font-weight-bold mb-4" }, _toDisplayString(_ctx.$t('default.page_not_found.title')), 513), [
            [_vShow, _ctx.statusCode == 404]
          ]),
          _withDirectives(_createVNode("h2", { class: "font-weight-bold mb-4" }, _toDisplayString(_ctx.$t('default.data_not_found.title')), 513), [
            [_vShow, _ctx.statusCode == 400]
          ]),
          _createVNode("a", _hoisted_4, _toDisplayString(_ctx.$t("default.page_not_found.back_to_home")), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("default.page_not_found.contact_us")), 1),
                _hoisted_10
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("p", null, [
                      _createVNode("a", {
                        class: "d-block",
                        href: _ctx.phoneToBind
                      }, _toDisplayString(_ctx.phoneDisplayText), 9, ["href"]),
                      _hoisted_15,
                      _createVNode("a", {
                        class: "d-block",
                        href: _ctx.emailToBind
                      }, _toDisplayString(_ctx.emailDisplayText), 9, ["href"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
})